import * as ActionTypes from "../ActionTypes";

const initialState = {
    isSuccess: false,
    isError: false,
    errorMessage: "",
    successMessage: "",
    expense_types: [],
    expenseTypeLoading: false,
    expense_subtypes: [],
    expenseSubtypeLoading: false,
    employee_expenses: [],
    employeeExpenseLoading: false,
    approver_expenses: [],
    approverExpenseLoading: false,
    employee_expense_csv: [],
    employeeExpenseCsvLoading: false,

};

export const ExpenseReducer = function (state = initialState, action) {
    switch (action.type) {
        case ActionTypes.EXPENSE_TYPE_GET_REQUEST:
        return {
            ...state,
            expenseTypeLoading: true,
            isSuccess: false,
            isError: false,
            errorMessage: "",
            expense_types: []
        };
        case ActionTypes.EXPENSE_TYPE_ADD_REQUEST:
        case ActionTypes.EXPENSE_TYPE_UPDATE_REQUEST:
        case ActionTypes.EXPENSE_TYPE_DELETE_REQUEST:
        return {
            ...state,
            expenseTypeLoading: true,
            isSuccess: false,
            isError: false,
            errorMessage: "",
        };

        case ActionTypes.EXPENSE_TYPE_GET_SUCCESS:
        case ActionTypes.EXPENSE_TYPE_ADD_SUCCESS:
        case ActionTypes.EXPENSE_TYPE_UPDATE_SUCCESS:
        case ActionTypes.EXPENSE_TYPE_DELETE_SUCCESS:
        return {
            ...state,
            expenseTypeLoading: false,
            isSuccess: true,
            successMessage: action.payload?.message,
            expense_types: action.payload?.data?.data || [],
        };

        case ActionTypes.EXPENSE_TYPE_GET_ERROR:
        case ActionTypes.EXPENSE_TYPE_ADD_ERROR:
        case ActionTypes.EXPENSE_TYPE_UPDATE_ERROR:
        case ActionTypes.EXPENSE_TYPE_DELETE_ERROR:
        return {
            ...state,
            expenseTypeLoading: false,
            isError: true,
            errorMessage:
            action.payload?.data?.error?.[0]?.message || "Error in expense type",
        };

        // Expense Subtype
        case ActionTypes.EXPENSE_SUBTYPE_GET_REQUEST:
        return {
            ...state,
            expenseSubtypeLoading: true,
            isSuccess: false,
            isError: false,
            errorMessage: "",
            expense_subtypes: []
        };
        case ActionTypes.EXPENSE_SUBTYPE_ADD_REQUEST:
        case ActionTypes.EXPENSE_SUBTYPE_UPDATE_REQUEST:
        case ActionTypes.EXPENSE_SUBTYPE_DELETE_REQUEST:
        return {
            ...state,
            expenseSubtypeLoading: true,
            isSuccess: false,
            isError: false,
            errorMessage: "",
        };

        case ActionTypes.EXPENSE_SUBTYPE_GET_SUCCESS:
        case ActionTypes.EXPENSE_SUBTYPE_ADD_SUCCESS:
        case ActionTypes.EXPENSE_SUBTYPE_UPDATE_SUCCESS:
        case ActionTypes.EXPENSE_SUBTYPE_DELETE_SUCCESS:
        return {
            ...state,
            expenseSubtypeLoading: false,
            isSuccess: true,
            successMessage: action.payload?.message,
            expense_subtypes: action.payload?.data?.data || [],
        };

        case ActionTypes.EXPENSE_SUBTYPE_GET_ERROR:
        case ActionTypes.EXPENSE_SUBTYPE_ADD_ERROR:
        case ActionTypes.EXPENSE_SUBTYPE_UPDATE_ERROR:
        case ActionTypes.EXPENSE_SUBTYPE_DELETE_ERROR:
        return {
            ...state,
            expenseSubtypeLoading: false,
            isError: true,
            errorMessage:
            action.payload?.data?.error?.[0]?.message ||
            "Error in expense subtype",
        };
        case ActionTypes.EMPLOYEE_EXPENSE_GET_REQUEST:
        return {
            ...state,
            employeeExpenseLoading: true,
            isSuccess: false,
            isError: false,
            errorMessage: "",
            employee_expenses: [],
        };

        case ActionTypes.EMPLOYEE_EXPENSE_ADD_REQUEST:
        case ActionTypes.EMPLOYEE_EXPENSE_UPDATE_REQUEST:
        case ActionTypes.EMPLOYEE_EXPENSE_DELETE_REQUEST:
        return {
            ...state,
            employeeExpenseLoading: true,
            isSuccess: false,
            isError: false,
            errorMessage: "",
        };

        case ActionTypes.EMPLOYEE_EXPENSE_GET_SUCCESS:
        case ActionTypes.EMPLOYEE_EXPENSE_ADD_SUCCESS:
        case ActionTypes.EMPLOYEE_EXPENSE_UPDATE_SUCCESS:
        case ActionTypes.EMPLOYEE_EXPENSE_DELETE_SUCCESS:
        return {
            ...state,
            employeeExpenseLoading: false,
            isSuccess: true,
            successMessage: action.payload?.message,
            employee_expenses: action.payload?.data?.data || [],
        };

        case ActionTypes.EMPLOYEE_EXPENSE_GET_ERROR:
        case ActionTypes.EMPLOYEE_EXPENSE_ADD_ERROR:
        case ActionTypes.EMPLOYEE_EXPENSE_UPDATE_ERROR:
        case ActionTypes.EMPLOYEE_EXPENSE_DELETE_ERROR:
        return {
            ...state,
            employeeExpenseLoading: false,
            isError: true,
            errorMessage:
            action.payload?.data?.error?.[0]?.message || "Error in employee expense",
        };
        // approver
        case ActionTypes.APPROVER_EXPENSE_GET_REQUEST :
        return {
            ...state,
            approverExpenseLoading: true,
            isSuccess: false,
            isError: false,
            errorMessage: "",
            approver_expenses: [],
        };

        case ActionTypes.APPROVER_EXPENSE_UPDATE_REQUEST :
        return {
            ...state,
            approverExpenseLoading: true,
            isSuccess: false,
            isError: false,
            errorMessage: "",
        };

        case ActionTypes.APPROVER_EXPENSE_GET_SUCCESS:
        case ActionTypes.APPROVER_EXPENSE_UPDATE_SUCCESS:
        return {
            ...state,
            approverExpenseLoading: false,
            isSuccess: true,
            successMessage: action.payload?.message,
            approver_expenses: action.payload?.data?.data || [],
        };

        case ActionTypes.APPROVER_EXPENSE_GET_ERROR:
        case ActionTypes.APPROVER_EXPENSE_UPDATE_ERROR:
        return {
            ...state,
            approverExpenseLoading: false,
            isError: true,
            errorMessage:
            action.payload?.data?.error?.[0]?.message || "Error in approver expense",
        };
        case ActionTypes.EMPLOYEE_EXPENSE_CSV_GET_REQUEST :
        return {
            ...state,
            employeeExpenseCsvLoading: true,
            isSuccess: false,
            isError: false,
            errorMessage: "",
            employee_expense_csv: [],
        };
        case ActionTypes.EMPLOYEE_EXPENSE_CSV_GET_SUCCESS:
        return {
            ...state,
            employeeExpenseCsvLoading: false,
            isSuccess: true,
            successMessage: action.payload?.message,
            employee_expense_csv: action.payload?.data?.data || [],
        };

        case ActionTypes.EMPLOYEE_EXPENSE_CSV_GET_ERROR:
        return {
            ...state,
            employeeExpenseCsvLoading: false,
            isError: true,
            errorMessage:
            action.payload?.data?.error?.[0]?.message || "Error in employee expense csv",
        };
        default:
        return state;
    }
};